import { ObjectTypes, Services } from '@diligentcorp/rc-service-object-mapping';

export const relationshipTypeKeys = [
  ObjectTypes.EVIDENCE,
  ObjectTypes.CONTROL,
  ObjectTypes.PROCESS,
  ObjectTypes.OBJECTIVE,
  ObjectTypes.CONTROL_ASSESSMENT,
  ObjectTypes.RISK,
  ObjectTypes.RISK_MITIGATION,
  ObjectTypes.RISK_EVENT_ASSESSMENT,
] as const;

export type RelationshipTypeKey = (typeof relationshipTypeKeys)[number];

export const relationshipTypeEntitlements: ReadonlyMap<
  RelationshipTypeKey,
  ReadonlyArray<string>
> = new Map([
  [ObjectTypes.EVIDENCE, [Services.INTERNAL_CONTROLS]],
  [ObjectTypes.PROCESS, [Services.RISK_MANAGER]],
  [ObjectTypes.OBJECTIVE, [Services.RISK_MANAGER]],
  [ObjectTypes.RISK, [Services.RISK_MANAGER]],
  [ObjectTypes.RISK_MITIGATION, [Services.RISK_MANAGER]],
  [ObjectTypes.RISK_EVENT_ASSESSMENT, [Services.RISK_MANAGER]],
]);

export const relationshipTypeEntitlementsAnyOf: ReadonlyMap<
  RelationshipTypeKey,
  ReadonlyArray<string>
> = new Map([
  [ObjectTypes.CONTROL, [Services.RISK_MANAGER, Services.INTERNAL_CONTROLS]],
  [
    ObjectTypes.CONTROL_ASSESSMENT,
    [Services.RISK_MANAGER, Services.INTERNAL_CONTROLS],
  ],
]);
